module.exports = __webpack_public_path__ + "img/ic-morder-arrow-right.25e3716e.svg";